import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { roles, USER_TYPES } from 'src/app/constant/constant';
import { ICard } from 'src/app/models/idcard';
import {
    ErrorModel,
    PromiseResult,
    ServerError
} from 'src/app/models/PromiseResult';
import { AppointmentService } from 'src/app/services/appointment.service';
import { DoctorsService } from 'src/app/services/doctors.service';
import { DoctorBreadcrumbService } from '../../shared/breadcrumb.service';
import { Title } from '@angular/platform-browser';
import { TraceClassDecorator } from '@sentry/angular';
import { MessagecenterService } from 'src/app/services/messagecenter.service';
import { appointmentGetQuery } from '../../../../models/appointment';
import { TokenService } from '../../../../utilities/token.service';
import { consultation_status } from '../../../../models/consultdoctors';
import { ProviderStateService } from 'src/app/services/provider-state.service';

//"assets/images/defualts/default_doc_profile.jpg"

class CommonData {
    Name: string = '';
    patientImg: string = 'assets/images/defualts/default_doc_profile.jpg';
    JoinLink: string = '';
    patientGuid: string = '';
}

export class AppointmentToShow extends CommonData {
    dateOfConsultation: string = '';
    consultationId: string = '';
}
//"assets/images/defualts/default_doc_profile.jpg"
export class MessageToShow extends CommonData {
    date: string = '';
    messageId: number;
    userID: string;
}
@TraceClassDecorator()
@Component({
    selector: 'app-other-medical-profession-home',
    templateUrl: './other-medical-profession-home.component.html',
    styleUrls: [
        './other-medical-profession-home.component.css',
        '../../../../../assets/css/custom-egd.css'
    ]
})
export class OtherMedicalProfessionHomeComponent implements OnInit {
    readonly userTypes = USER_TYPES;
    slug: string = "";
    response: PromiseResult;
    error: ErrorModel;
    serverError: ServerError;
    posting: boolean;
    displaycard: boolean;
    loading: boolean;
    doctorICard: ICard;
    loading1: boolean = true;
    body: appointmentGetQuery = new appointmentGetQuery();

    listOfAppointmentToShow: AppointmentToShow[] = [];
    listOfMessageToShow: MessageToShow[] = [];
    listOfOnGoingAppointmentToShow: AppointmentToShow[] = [];
    // initateLoader: boolean = false;

    // initate_response: PromiseResult;
    // initate_error: ErrorModel;
    // initate_serverError: ServerError;

    // join_zoom = "";

    // iniateDialog: boolean = false;

    public readonly role_id: number;
    constructor(
        private readonly doctorsService: DoctorsService,
        private readonly appointmentService: AppointmentService,
        private readonly breadcrumbService: DoctorBreadcrumbService,
        private readonly titleService: Title,
        private readonly messageCenterService: MessagecenterService,
        private readonly tokenUtil: TokenService,
        private readonly providerstateService: ProviderStateService
    ) {
        this.breadcrumbService.setItems([{ label: 'Dashboard' }]);
        this.role_id = this.tokenUtil.findRoleId();
        // this.initateLoader = false;
    }

    async ngOnInit(): Promise<void> {
        this.titleService.setTitle('Dashboard - Other Medical Profession Home');
        this.slug = this.providerstateService.getProviderSlug();

        this.loading = true;
        this.loading1 = true;
        this.doctorICard = {
            first_name: '',
            middle_name: '',
            last_name: '',
            date_of_birth: '',
            avatar_url: '',
            doctor_profile: {
                doctor_number: 0,
                is_active: true,
                speciality: {
                    specialty_name: ''
                }
            },
            country: {
                country_name: '',
                acronym: ''
            },
            role_type: {
                id: null,
                title: ''
            },
            other_medical_profile: {
                is_active: null,
                other_medical_id: null,
                primary_occupation: ''
            }
        };

        this.posting = false;
        this.ResetResultModels();
        this.body.user_guid = sessionStorage.getItem('userid');
        this.body.self = true;
        await this.getIDCardData();
        // await this.getMyAppointments();
        this.loading = false;
        this.loading1 = false;
        await this.getconsultationList();
        await this.getMessageList();
    }

    private ResetResultModels(): void {
        this.response = {
            success: null,
            error: null,
            data: null
        };
        this.serverError = {
            statusCode: null,
            error: null,
            message: null
        };
    }

    async getconsultationList() {
        this.ResetResultModels();
        this.loading = true;
        await this.appointmentService
            .GetAllMyAssignedPatients(this.body)
            .toPromise()
            .then((result) => {
                if (result.success) {
                    for (const data of result.data) {
                        const appointment = new AppointmentToShow();
                        appointment.Name =
                            data.accounts.first_name +
                            ' ' +
                            (data.accounts.middle_name==null?'':data.accounts.middle_name) +
                            ' ' +
                            data.accounts.last_name;
                        appointment.patientGuid = data.patient_guid;
                        appointment.consultationId = data.id;
                        appointment.dateOfConsultation =
                            data.consultation_date;
                        appointment.patientImg = data.accounts
                            .avatar_url
                            ? data.accounts.avatar_url
                            : appointment.patientImg;
                        if (data.consultations_left == (data.priority_type.number_of_consultations - 1)
                            && data.consultation_status == consultation_status.scheduled) {
                            if (this.listOfAppointmentToShow.length < 5)
                                this.listOfAppointmentToShow.push(appointment);
                        } else {
                            if (this.listOfOnGoingAppointmentToShow.length < 5)
                                this.listOfOnGoingAppointmentToShow.push(appointment);

                        }
                    }
                }
            })
            .catch((error: HttpErrorResponse) => {
                this.serverError = error.error;
                this.response.success = false;
                this.loading = false;
            });
    }

    async getMessageList() {
        if (this.role_id == 7) return;
        this.ResetResultModels();
        this.loading = true;
        await this.messageCenterService
            .getMessagesForDashborad(roles.doctor)
            .toPromise()
            .then((result) => {
                if (result.success) {
                    for (let i = 0; i < 2; i++) {
                        const message = new MessageToShow();
                        //for(let i=0;i<result.data.message_list.rows;i++){
                        if (
                            result.data.message_list.rows[i].messages
                                .p_accounts == null
                        ) {
                            message.Name =
                                result.data.message_list.rows[i].messages
                                    .egd_users.first_name +
                                ' ' +
                                (result.data.message_list.rows[i].messages
                                    .egd_users.middle_name==null?'':result.data.message_list.rows[i].messages
                                    .egd_users.middle_name) +
                                ' ' +
                                result.data.message_list.rows[i].messages
                                    .egd_users.last_name;
                            message.date =
                                result.data.message_list.rows[
                                    i
                                ].messages.created_at;
                            message.userID =
                                result.data.message_list.rows[
                                    i
                                ].messages.user_guid;
                            message.messageId =
                                result.data.message_list.rows[i].messages.id;
                            // messageToShow.patientImg=result.data[i].accounts.avatar_url.length>0?result.data[i].accounts.avatar_url:'assets/images/defualts/default_doc_profile.jpg';
                            this.listOfMessageToShow.push(message);
                        } else {
                            const message = new MessageToShow();
                            message.Name =
                                result.data.message_list.rows[i].messages
                                    .p_accounts.first_name +
                                ' ' +
                                (result.data.message_list.rows[i].messages
                                    .p_accounts.middle_name==null?'':result.data.message_list.rows[i].messages
                                    .p_accounts.middle_name) +
                                ' ' +
                                result.data.message_list.rows[i].messages
                                    .p_accounts.last_name;
                            message.date =
                                result.data.message_list.rows[
                                    i
                                ].messages.created_at;

                            message.userID =
                                sessionStorage.getItem('userid');
                            message.messageId =
                                result.data.message_list.rows[i].messages.id;
                            this.listOfMessageToShow.push(message);

                        }
                    }
                }
            })
            .catch((error: HttpErrorResponse) => {
                this.serverError = error.error;
                this.response.success = false;
                this.loading = false;
            });
    }

    async getIDCardData() {
        this.ResetResultModels();
        this.loading = true;
        await this.doctorsService
            .getDoctorIDCardData(this.body.user_guid)
            .toPromise()
            .then((result) => {
                this.response = result;
                if (this.response.success)
                    this.doctorICard = result.data;
                else this.error = result.error;
                this.loading = false;
                this.posting = false;
            })
            .catch((error: HttpErrorResponse) => {
                this.serverError = error.error;
                this.response.success = false;
                this.loading = false;
            });
    }

    showcardDialog() {
        this.posting = true;
        this.displaycard = true;
        this.posting = false;
    }
    close() {
        this.displaycard = false;
    }

}
